export enum PaymentSetupType {
  WORLDPAY,
  APPLE_PAY,
}
